export default __webpack_public_path__ + "static/media/eye.6c84552a.svg";